export default {
  title: 'Recente campagneprestaties',
  recipients: '{{recipients}} ontvangers',
  error_messages: {
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
